import { render } from "./TasksView.vue?vue&type=template&id=578eb3fa&scoped=true"
import script from "./TasksView.vue?vue&type=script&lang=js"
export * from "./TasksView.vue?vue&type=script&lang=js"

import "./TasksView.vue?vue&type=style&index=0&id=578eb3fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578eb3fa"]])

export default __exports__